import axios, { CancelTokenSource } from 'axios';

type GenerateResultParams = {
  url: string;
  token: string;
  requestData: object;
  requestSource: CancelTokenSource;
};

const generateResult = async <ResponseGeneric>({
  url,
  token,
  requestData,
  requestSource,
}: GenerateResultParams) => {
  if (!url || !token) {
    throw new Error('Generator is not configured');
  }

  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };
  const timeout = 120000; // 120 secs
  const { data } = await axios.post<ResponseGeneric>(url, requestData, {
    headers,
    timeout,
    cancelToken: requestSource.token,
  });

  return data;
};

export default generateResult;
